export const mapDirectionsSelector = state =>state.mapDirectionsReducer;

export const originSelector = state =>state.tripCreateReducer.origin;
export const destinationSelector = state =>state.tripCreateReducer.destination;
export const wayPointsSelector = state =>state.tripCreateReducer.wayPoints;
export const zoomSelector = state =>state.tripCreateReducer.zoom;
export const centerSelector = state =>state.tripCreateReducer.center;
export const preserveViewportSelector = state =>state.tripCreateReducer.preserveViewport;
